import { combineEpics } from 'redux-observable';
import { FETCH_CAN_EDIT_USER, FetchIsRestrictedImpersonatee } from '../actions/IsRestrictedImpersonateeActions';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import ImpersonationAPI from '../api/ImpersonationAPI';
import { getFetchIsRestrictedImpersonateesRequestStatus } from '../selectors/RequestStatusSelector';
import { RequestEpicDescriptor, requestEntity } from 'settings-ui-lib/utils/epics';
const fetchIsRestrictedImpersonatee = requestEntity(new RequestEpicDescriptor({
  apiFunction: ImpersonationAPI.getIsRestrictedImpersonatee,
  initiatingActionType: FETCH_CAN_EDIT_USER,
  requestStatusSelector: getFetchIsRestrictedImpersonateesRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.FAILED],
  requestActions: FetchIsRestrictedImpersonatee
}));
export default combineEpics(fetchIsRestrictedImpersonatee);